var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87778 3.85333L9.22223 8.92888C9.69666 9.30505 10.3376 9.51612 11.0056 9.51612C11.6735 9.51612 12.3145 9.30505 12.7889 8.92888L19.1222 3.86223M4.38889 1H17.6111C19.4827 1 21 2.21381 21 3.71111V14.2889C21 15.7862 19.4827 17 17.6111 17H4.38889C2.51726 17 1 15.7862 1 14.2889V3.71111C1 2.21381 2.51726 1 4.38889 1Z",
    stroke: "#1C1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.75a6be8e4f0d32811b683a9f6b25f29e.svg";
export { ForwardRef as ReactComponent };